import { defineStore } from 'pinia';
import api from '@/services/api';
import ubicacion_model from '@/shared/models/ubicacion_model';
import { getParamsUrl } from './ubicacion_utils';

export const useUbicacionStore = defineStore('ubicacionStore', {
  state: () => ({
    entity: 'ubicacion',
    ubicaciones: [],
    ubicacion: { ...ubicacion_model },
    page: 1,
    filters: {},
  }),
  getters: {},
  actions: {
    async findAllUbicacionHTTP(params) {
      const result = await api.get(
        `/${this.entity}?${getParamsUrl({ page: +this.page, Activo: true, ...this.filters, ...params, limit: 12 })}`,
      );
      if (result && result.data.length > 0) {
        this.ubicaciones.push(...result.data);
        this.setPage(this.page + 1);
        return true;
      }
      return false;
    },
    async saveUbicacion() {
      if (this.ubicacion.Codigo) {
        return await this.updateUbicacionHTTP();
      } else {
        return await this.createUbicacionHTTP();
      }
    },
    async createUbicacionHTTP() {
      return await api.post(`/${this.entity}`, this.ubicacion);
    },
    async updateUbicacionHTTP() {
      return await api.patch(`/${this.entity}/${this.ubicacion.Codigo}`, this.ubicacion);
    },
    async deleteUbicacionHTTP(ubicacion) {
      console.log(ubicacion);
      return await api.patch(`/${this.entity}/${ubicacion.Codigo}`, {
        ...ubicacion,
        Activo: false,
      });
    },
    cleanUbicacion() {
      this.ubicacion = { ...ubicacion_model };
    },
    setPage(page) {
      this.page = page;
    },
    async firstRequest() {
      this.setPage(1);
      this.emptyList();
      await this.findAllUbicacionHTTP();
    },
    emptyList() {
      this.ubicaciones = [];
    },
  },
});
